module.exports = __webpack_public_path__ + "img/home3.e88775a3.jpg";